<template>
  <div class="pa-2">
    <section class="stop-hierarchy-card">
      <div class="pa-4">
        <v-card-text class="d-flex justify-space-between pa-0 pb-3" style="font-size: 1rem">
          <div class="d-flex">
            <div class="mr-4">
              <span class="font-weight-bold"> Parada: </span>
              <span class="font-weight-regular"> {{ stop.stopNumber || stop.StopNumber }} </span>
            </div>
            <div class="mr-4">
              <span class="font-weight-bold">Destinatário: </span>
              <TruncateDataWithTooltip
                :data="stop.nameRecipient || stop.NameRecipient"
                :lengthDataToTruncate="truncateLimit"
              ></TruncateDataWithTooltip>
            </div>
            <div class="mr-4">
              <span class="font-weight-bold">Cidade: </span>
              <TruncateDataWithTooltip
                :data="stop.nameCityRecipient || stop.NameCityRecipient"
                :lengthDataToTruncate="truncateLimit"
              ></TruncateDataWithTooltip>
            </div>
          </div>
          <v-icon @click="toggleCollapsed">
            {{ isCollapsed ? 'mdi-chevron-right' : 'mdi-chevron-down' }}
          </v-icon>
        </v-card-text>
        <v-card-text class="d-flex pa-0">
          <v-col class="pa-0" cols="12" md="12">
            <span class="font-weight-bold text--secondary">Valor das Mercadorias: </span>
            <span class="font-weight-regular mr-4">{{ formatPrice(stop.totalPriceNfes || stop.TotalPriceNfes) }}</span>
            <span class="font-weight-bold text--secondary">Frete embarcador: </span>
            <span class="font-weight-regular mr-4">{{
              formatPrice(stop.totalPriceDeliveries || stop.TotalPriceDeliveries)
            }}</span>
            <span class="font-weight-bold text--secondary">Peso: </span>
            <span class="font-weight-regular mr-4"
              >{{ formatWeight(stop.weightDeliveries || stop.WeightDeliveries || 0) }}kg</span
            >
            <span class="font-weight-bold text--secondary">Quantidade de entregas: </span>
            <span class="font-weight-regular"> {{ stop?.amountDeliveries || stop.AmountDeliveries }} </span>
          </v-col>
        </v-card-text>
      </div>
      <div v-if="!isCollapsed">
        <DeliveryHierarchyCard
          v-for="item in alocatedDeliveries"
          :importedSuccessfully="importedSuccessfully"
          :delivery="item"
          :key="item.id"
        />
      </div>
      <v-progress-linear v-if="isLoadingAlocated" indeterminate color="primary" class="mr-2"></v-progress-linear>
    </section>
  </div>
</template>

<script>
import TruncateDataWithTooltip from '@/components/Table/TruncateDataWithTooltip.vue';
import DeliveryHierarchyCard from '@/components/ManualBoardingImport/Stepper/Step7/HierarchyDetails/DeliveryHierarchyDetails.vue';
import copyToClipboard from '@/utils/copyToClipboard';
import maskPrice from '@/utils/maskPrice';
import maskWeight from '@/utils/maskWeight';
import { mapActions } from 'vuex';
export default {
  components: {
    TruncateDataWithTooltip,
    DeliveryHierarchyCard
  },
  props: {
    stop: {
      default: () => ({}),
      type: Object
    },
    importedSuccessfully: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    isLoadingAlocated: false,
    isCollapsed: true,
    alocatedDeliveries: []
  }),
  computed: {
    truncateLimit() {
      const width = this.$vuetify.breakpoint.width;
      if (width < 1360) return 8;
      if (width < 1440) return 10;
      if (width < 1520) return 16;
      if (width < 1680) return 20;
      if (width < 1820) return 26;
      return 34;
    }
  },
  methods: {
    ...mapActions('ImportManualStopsStore', ['getDeliveriesByStopId', 'allocateDelivery']),
    async toggleCollapsed() {
      if (!this.isCollapsed) {
        this.isCollapsed = true;
      } else {
        this.isLoadingAlocated = true;
        try {
          if (this.importedSuccessfully) {
            this.alocatedDeliveries = this.stop.DeliveriesTemp;
          } else {
            const data = await this.getDeliveriesByStopId(this.stop.id);
            this.alocatedDeliveries = data;
          }
          this.isCollapsed = false;
        } catch (err) {
          console.error(err);
        } finally {
          this.isLoadingAlocated = false;
        }
      }
    },
    formatPrice(price) {
      return maskPrice(price);
    },
    formatWeight(price) {
      return maskWeight(price);
    },
    copy(str) {
      copyToClipboard(str);
    }
  }
};
</script>

<style scoped>
.stop-hierarchy-card {
  min-width: 560px;
  width: 100%;
  min-height: 90px;
  height: auto;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
</style>
